module.exports = __webpack_public_path__ + "static/GridA-1d724b62c78b45f4c0a831d003e60da5.png";